<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;height: 100%" @tab-click="handleTabClick">
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_UserManagement')" name="userManage" style="width:100%;height: 100%">
          <user-manage ref="userManage" :tab-title="$t('CargoMsg.Cargo_UserManagement')" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_RoleUserSettings')" name="userRoleManage" style="width:100%;height: 100%">
          <user-role-manage ref="userRoleManage" :tab-title="$t('CargoMsg.Cargo_RoleUserSettings')" />
        </el-tab-pane>
        <el-tab-pane v-if="useUserPort" :lazy="true" :label="$t('SystemMaintenance.AssociatedRoutesAndPorts')" name="associatedPort" style="width:100%;height: 100%">
          <user-port-tab ref="associatedPort" :tab-title="$t('SystemMaintenance.AssociatedRoutesAndPorts')" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import userManage from '@/views/cargo/v0/SystemMaintenance/components/user/userManage'
import userRoleManage from '@/views/cargo/v0/SystemMaintenance/components/user/userRoleManage'
import userPortTab from '@/views/cargo/v0/SystemMaintenance/components/user/userPortTab'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'FmUser',
  components: {
    userManage,
    userPortTab,
    userRoleManage
  },
  data() {
    return {
      loading: true,
      useUserPort: false,
      activeTabName: 'userManage'
    }
  },
  watch: {
    $route: {
      handler: function(route) {
      },
      immediate: true
    }
  },
  mounted() {
  },
  async created() {
    this.loading = false
    await cache.load(cacheName.CONFIG)
    this.useUserPort = parseInt(cache.config.get('useUserPort')) === 1
  },
  methods: {
    handleTabClick() {
    },
    onReady(params) {
    }
  }
}
</script>
